import InvestorDataChangeForm from './investor-data-change-form';

export default InvestorDataChangeForm;
